import * as React from 'react';
import type { SVGProps } from 'react';
const ProductIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={40} height={40} fill="#605DEC" rx={20} />
    <g clipPath="url(#a)">
      <path fill="#fff" fillOpacity={0.01} d="M33 7H7v26h26V7Z" />
      <path
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M30.835 14.583 20 9.166 9.168 14.583v10.833l10.833 5.417 10.834-5.416V14.582Z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M9.168 14.584 20.001 20M20 30.833V20M30.833 14.584 20 20M25.415 11.875l-10.833 5.417"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M7 7h26v26H7z" />
      </clipPath>
    </defs>
  </svg>
);
export default ProductIcon;
